import React from 'react'
import {NextSeo} from 'next-seo'
import {withRouter} from 'next/router'
import {inject, observer} from 'mobx-react'
import TrafficSubmissionFlow from "~/pages/traffic-tickets/flow"
import {STATES} from "~/utilities/constants"

@inject(all => ({
    selectedState: all.store.trafficSubmission.selectedState,
}))
@observer
class StateTrafficPage extends React.Component {
    componentDidMount() {
        this.scrollUp()
    }

    scrollUp = () => {
        if (process.browser) {
            window.scrollTo({top: 0, behavior: 'smooth'})
        }
    }

    render() {
        const {slug} = this.props.router.query
        const state = slug?.replace('-traffic-tickets', '')
        const fullStateName = STATES[state.toUpperCase()]
        const title = `${fullStateName} Traffic Tickets | WinIt`
        let description = ''
        switch (state) {
            case 'pa':
                description = `In ${fullStateName}, common traffic violations include speeding and driving without headlights. The state enforces unique laws for driving in tunnels and construction zones. Utilize the WinIt app to challenge your ${fullStateName} traffic tickets with support from knowledgeable local lawyers.`
                break
            case 'ny':
                description = `Common traffic violations in ${fullStateName} include reckless driving and speeding. The state imposes high fines for speeding violations, especially in work zones. Leverage the WinIt app to dispute your ${fullStateName} traffic tickets by connecting with qualified local lawyers.`
                break
            case 'nj':
                description = `${fullStateName} penalizes tailgating and speeding, with high fines and points added to your license for such offenses. Use the WinIt app to contest your ${fullStateName} traffic tickets with the help of experienced local attorneys.`
                break
            case 'tx':
                description = `In ${fullStateName}, seatbelt violations and speeding are common infractions. The state strictly enforces seatbelt laws. Leverage the WinIt app to dispute your ${fullStateName} traffic tickets by connecting with experienced local attorneys.`
                break
            case 'fl':
                description = `In ${fullStateName}, common traffic violations include speeding and running red lights. The state imposes strict penalties for such offenses. Use the WinIt app to contest your ${fullStateName} traffic tickets with the assistance of experienced local attorneys.`
                break
            case 'ca':
                description = `Looking for an experienced lawyer to fight your ${fullStateName} traffic ticket? Use the Winit app and find the best ${fullStateName} traffic lawyers.`
                break
            case 'ga':
                description = `In ${fullStateName}, speeding and failure to stop at red lights are frequent violations. The state employs speed cameras in many school zones to enforce traffic laws. Utilize the WinIt app to challenge your ${fullStateName} traffic tickets with assistance from experienced local attorneys.`
                break
            case 'wa':
                description = `${fullStateName} State enforces strict distracted driving laws, with common violations including failure to yield and speeding. Utilize the WinIt app to challenge your ${fullStateName} traffic tickets with the help of qualified local lawyers.`
                break
            default:
                description = `Common traffic violations in ${fullStateName} include reckless driving and speeding. The state imposes high fines for speeding violations, especially in work zones. Leverage the WinIt app to dispute your ${fullStateName} traffic tickets by connecting with qualified local lawyers.`
                break
        }
        const canonical = `https://www.appwinit.com/${fullStateName?.toLowerCase()}-traffic-tickets`
        return (
          <>
            <NextSeo
              title={title}
              description={description}
              canonical={canonical}
              additionalMetaTags={[
                        {
                            property: "description",
                            content: description
                        }
                    ]}
            />
            <TrafficSubmissionFlow />
          </>
        )
    }
}

export default withRouter(StateTrafficPage)
